import { makeObservable, observable } from "mobx";

/**
 * The list of client feature toggles available in C8.
 *
 * It must be kept in sync with client feature toggles from
 * /PI-Base/JavaSrc/com/centricsoftware/pi/core/feature/C8FeatureFlags.java
 */
export default class FeatureTogglesStore {
	/** filter comments for hybrid users */
	@observable COMMENTS_FILTER_FOR_HYBRID_USERS: boolean = false;

	/** indicate if we need to disable the delayed filtering feature */
	@observable DISABLE_DELAYED_FILTERING: boolean = false;

	/** indicate if we need to disable recents feature */
	@observable DISABLE_RECENTS: boolean = false;

	/** Enable Archiving */
	@observable ENABLE_ARCHIVING: boolean = false;

	/** Enable Async Style Copy */
	@observable ENABLE_ASYNC_STYLE_COPY: boolean = false;

	/** Enable Factory Direct Development */
	@observable ENABLE_FACTORY_DIRECT_DEVELOPMENT: boolean = false;

	/** Enable Impact Analysis */
	@observable ENABLE_IMPACT_ANALYSIS: boolean = false;

	/** Use large icons for editable attributes */
	@observable UX_EDITABLE_LARGE_ICONS: boolean = false;

	/** Enable Material Composition editing */
	@observable MATERIAL_COMPOSITION: boolean = false;

	/** bring back single select input type for string attributes (none and multi-line text formats) when using "is" or "is not" */
	@observable RESTORE_SELECT_INPUT_FOR_EQUALS_OPERATORS: boolean = false;

	/** Enable React UI for Care and Composition Data Sheet */
	@observable CAREANDCOMPOSITION_DATASHEET_USE_REACT_UI: boolean = false;

	/** indicate if we need to restore deleted operators in custom view filters */
	@observable RESTORE_TEXT_COMPARISON_OPERATORS: boolean = false;

	/** Enable adding enum values without running Update Configuration */
	@observable ENABLE_ENUMVALUE_WITHOUT_CONFIG_UPDATE: boolean = false;

	/** Enable Update Weight Per BOM Qty Action */
	@observable ENABLE_UPDATE_WEIGHT_PER_BOM_QTY_ACTION: boolean = false;

	constructor() {
		makeObservable(this);
	}
}